export enum HealthProfileCategory {
  General = 'profileHealthGeneral',
  Medication = 'profileHealthMedication',
  Allergies = 'profileHealthAllergies',
}
